import React, { Component } from 'react';
import { authHeaderJson } from '../auth-header';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import EditIcon from '@material-ui/icons/Edit';
import DelIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import PlusIcon from '@material-ui/icons/Add';
import IconRefresh from '@material-ui/icons/Refresh';
import IconCheck from '@material-ui/icons/CheckCircleOutline';


import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import {
    IconButton, Dialog, Button, TextField, FormControlLabel,
    FormGroup, Radio, RadioGroup, FormControl, FormLabel, Fab,
    CircularProgress, DialogContentText, AppBar, Typography, Toolbar
} from '@material-ui/core'
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit,
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    numberField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 100,
    },
    radio: {
        height: 30,
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        marginRight: 5,
    },
    editor: {
        height: 320,
    },
    editor2: {
        height: 300
    },
    fab: {
        marginTop: theme.spacing.unit * 2,
        position: 'absolute',
        right: theme.spacing.unit * 2,
    },
    grow: {
        flexGrow: 1,
    },
});


class NotificationsList extends Component {
    static displayName = NotificationsList.name;

    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            loading: true,
            tabVal: 0,
            dialogOpen: false,
            openDel: false,
            notDataId: 0,
            notDataShortName: '',
            notDataSubject: '',
            notDataDayInMonth: 10,
            notDataEnabledEnum: "1",
            notDataConditionEnum: "1",
            notDataMailTemplate: "",
            errors: []
        };
        this.handleClose = this.handleClose.bind(this);
    };


    componentDidMount() {
        this.loadNots();
    }
    newNot() {
        this.setState({
            notDataId: 0,
            notDataShortName: '',
            notDataDayInMonth: 10,
            notDataEnabledEnum: "1",
            notDataConditionEnum: "1",
            notDataMailTemplate: "",
            notDataSubject: '',
            dialogOpen: true
        });
    }
    editRow(event, id) {
        fetch('api/NotificationTemplates/' + id, { headers: authHeaderJson() })
            .then(res => res.json())
            .then(data => {
                this.setState({
                    notDataId: data.id,
                    notDataShortName: data.shortName,
                    notDataDayInMonth: data.dayInMonth,
                    notDataEnabledEnum: data.enabledEnum.toString(),
                    notDataConditionEnum: data.conditionEnum.toString(),
                    notDataMailTemplate: data.mailTemplate,
                    notDataSubject: data.subject,
                    dialogOpen: true
                });
            })
            .catch(err => { console.error(err); })
    }
    saveNot() {
        let errs = [];
        if (this.state.notDataShortName.length <= 0) errs.push("notDataShortName");
        if (this.state.notDataDayInMonth < 1 || this.state.notDataDayInMonth > 31) errs.push("notDataDayInMonth");
        if (this.state.notDataMailTemplate.length <= 0) errs.push("notDataMailTemplate");
        if (this.state.notDataSubject.length <= 0) errs.push("notDataSubject");

        this.setState({ errors: errs });
        if (errs.length > 0)
            return;
        var data = {
            id: this.state.notDataId,
            shortName: this.state.notDataShortName,
            dayInMonth: this.state.notDataDayInMonth,
            enabledEnum: this.state.notDataEnabledEnum,
            conditionEnum: this.state.notDataConditionEnum,
            mailTemplate: this.state.notDataMailTemplate,
            subject: this.state.notDataSubject
        }
        //       console.log(JSON.stringify(data));

        fetch('api/NotificationTemplates' + (data.id === 0 ? '' : '/' + data.id), { headers: authHeaderJson(), method: (data.id === 0 ? "post" : 'put'), body: JSON.stringify(data) })
            //            .then(response => response.json())
            .then(data => {
                //console.log(data);
                this.setState({ dialogOpen: false });
                this.loadNots();
            })
            .catch(err => {
                console.error(err);
                //                this.setState({ loading: false });
            });
    }
    delRow(event, id) {
        fetch('api/NotificationTemplates/' + id, { headers: authHeaderJson() })
            .then(res => res.json())
            .then(data => {
                this.setState({
                    notDataId: data.id,
                    notDataShortName: data.shortName,
                    notDataDayInMonth: data.dayInMonth,
                    notDataEnabledEnum: data.enabledEnum.toString(),
                    notDataConditionEnum: data.conditionEnum.toString(),
                    notDataMailTemplate: data.mailTemplate,
                    openDel: true
                });
            })
            .catch(err => { console.error(err); })
    }
    delRowConf() {
        var id = this.state.notDataId;
        fetch('api/NotificationTemplates/' + id, { headers: authHeaderJson(), method: 'delete' })
            .then(res => res.json())
            .then(data => {
                this.setState({
                    openDel: false
                });
                this.loadNots();
            })
            .catch(err => { console.error(err); })
    }
    loadNots() {
        this.setState({ loading: true });

        fetch('api/NotificationTemplates', { headers: authHeaderJson() })
            .then(response => response.json())
            .then(data => {
                this.setState({ listData: data, loading: false });
            })
            .catch(err => {
                this.setState({ loading: false });
            });
    }


    renderForecastsTable(nots) {
        return (
            <Table padding="none">
                <TableHead>
                    <TableRow>
                        <TableCell padding="dense">Názov</TableCell>
                        <TableCell>Deň</TableCell>
                        <TableCell>Povolené</TableCell>
                        <TableCell>Podmienka</TableCell>
                        <TableCell></TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {nots.map(not =>
                        <TableRow key={not.id} onDoubleClick={event => this.editRow(event, not.id)} hover>
                            <TableCell padding='dense' >{not.shortName}</TableCell>
                            <TableCell>{not.dayInMonth}</TableCell>
                            <TableCell>{not.enabledEnum === 1 ? <IconCheck /> : ''}</TableCell>
                            <TableCell>{not.conditionEnum === 1 ? 'Neodovzdané' : 'Odovzdané'}</TableCell>
                            <TableCell>
                                <IconButton onClick={event => this.editRow(event, not.id)}><EditIcon /></IconButton >
                                <IconButton onClick={event => this.delRow(event, not.id)}><DelIcon /></IconButton>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        );
    }


    handleClose() {
        this.setState({ dialogOpen: false });
    }

    handleInputChange({ target }) {
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [target.name]: value
        });
    }

    render() {
        const { classes } = this.props;
        const { fullScreen } = this.props;

        let contents = this.state.loading ? <CircularProgress /> : this.renderForecastsTable(this.state.listData);

        return (
            <div className={classes.root} >
                <AppBar position="static">
                    <Toolbar>
                        <Typography className={classes.grow} variant="h6" color="inherit">Termíny</Typography>
                        <IconButton color="inherit" onClick={this.loadNots.bind(this)}>
                            <IconRefresh />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Paper>
                    {contents}
                    <Fab color="secondary" className={classes.fab} onClick={event => this.newNot()}><PlusIcon /></Fab>
                </Paper>

                <Dialog
                    open={this.state.openDel}
                    onClose={(e) => this.setState({ openDel: false })}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Naozaj vymazať?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">Naozaj si prajete vymazať notifikáciu &quot;{this.state.notDataShortName}&quot; ?</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={e => this.delRowConf()} color="secondary">Vymazať</Button>
                        <Button onClick={(e) => this.setState({ openDel: false })} color="secondary" autoFocus>Ponechať</Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    fullScreen={fullScreen}
                    open={this.state.dialogOpen}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                    scroll="paper"
                    maxWidth="lg"
                >
                    <DialogTitle id="responsive-dialog-title">{"Notifikácia"}</DialogTitle>
                    <DialogContent>
                        {this.state.errors.length > 0 && <FormLabel error>Formulár obsahuje chyby, nie je možné ho odoslať</FormLabel>}
                        <FormGroup row>
                            <TextField error={this.state.errors.some(x => x === 'notDataShortName')}
                                label="Krátky názov notifikácie"
                                className={classes.textField}
                                required name="notDataShortName"
                                margin="normal"
                                value={this.state.notDataShortName}
                                onChange={this.handleInputChange.bind(this)} autoFocus
                            />
                            <TextField error={this.state.errors.some(x => x === 'notDataDayInMonth')}
                                label="Deň v mesiaci"
                                className={classes.numberField}
                                type="number"
                                margin="normal"
                                name="notDataDayInMonth"
                                value={this.state.notDataDayInMonth}
                                onChange={this.handleInputChange.bind(this)}
                            />
                        </FormGroup>
                        <FormGroup row>
                            <FormControl component="fieldset" variant="outlined">
                                <FormLabel component="legend" >Odosielanie mailov</FormLabel >
                                <RadioGroup
                                    margin="normal"
                                    aria-label="Enabled"
                                    name="notDataEnabledEnum"
                                    className={classes.group}
                                    value={this.state.notDataEnabledEnum}
                                    onChange={this.handleInputChange.bind(this)}
                                >
                                    <FormControlLabel value="1" control={<Radio />} label="povolené" className={classes.radio} />
                                    <FormControlLabel value="0" control={<Radio />} label="zakázané" className={classes.radio} />
                                </RadioGroup>
                            </FormControl>
                            <FormControl component="fieldset" variant="filled">
                                <FormLabel component="legend">, za podmienky ak</FormLabel >
                                <RadioGroup
                                    margin="normal"
                                    aria-label="Gender"
                                    name="notDataConditionEnum"
                                    className={classes.group}
                                    value={this.state.notDataConditionEnum}
                                    onChange={this.handleInputChange.bind(this)}
                                >
                                    <FormControlLabel value="1" control={<Radio />} label="dáta neodovzdané" className={classes.radio} />
                                    <FormControlLabel value="2" control={<Radio />} label="dáta odovzdané" className={classes.radio} />
                                </RadioGroup>
                            </FormControl>
                        </FormGroup>
                        <FormLabel>Obsah mailu</FormLabel>
                        <TextField
                            label="Predmet" required error={this.state.errors.some(x => x === 'notDataSubject')}
                            margin="normal" fullWidth={true}
                            name="notDataSubject"
                            value={this.state.notDataSubject}
                            onChange={this.handleInputChange.bind(this)}
                        />
                        <div className={classes.editor}>
                            <ReactQuill
                                name="notDataMailTemplate" required
                                value={this.state.notDataMailTemplate}
                                onChange={this.handleWYSIWYG.bind(this)}
                                className={classes.editor2} theme='snow' />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={e => this.saveNot()} color="secondary" autoFocus variant="outlined"><SaveIcon />Uložiť</Button>
                        <Button onClick={e => this.handleClose()} color="secondary" variant="outlined"><CancelIcon />Zrušiť</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
    handleWYSIWYG(val) { this.setState({ notDataMailTemplate: val }); }
}
NotificationsList.propTypes = {
    classes: PropTypes.object.isRequired,
    fullScreen: PropTypes.bool.isRequired,
};

export default withMobileDialog()(withStyles(styles)(NotificationsList));


// WEBPACK FOOTER //
// ./src/components/pssr/Notifications.jsx